export default {
  uiStates: {
    title: "Каталог на UI состојби",
    subtitle: "Визуелна референца за сите состојби на компоненти — само за развивачи.",

    // Tab names
    tabs: {
      errors: "Состојби на грешки",
      emptyStates: "Празни состојби",
      loading: "Скелетони за вчитување",
      dialogs: "Состојби на дијалози",
      misc: "Разно",
    },

    // State labels
    labels: {
      server: "Серверска грешка",
      network: "Мрежна грешка",
      timeout: "Истекување на време",
      unknown: "Непозната грешка",
      empty: "Празно (нема визити)",
      filteredEmpty: "Филтрирано празно",
      paymentRequired: "Очекува уплата",
      noResults: "Нема резултати",
      noSamples: "Нема примероци",
      noSales: "Нема продажби",
      noProducts: "Нема производи",
      noPayments: "Нема плаќања",
      noVisits: "Нема визити (Досие на пациент)",
      noTests: "Нема испитувања (Досие на пациент)",
      noFlaggedResults: "Нема означени резултати",
      dialogHistoryEmpty: "Дијалог за историја — Празен",
      dialogResultsEmpty: "Дијалог за резултати — Празен",
      snackbarSuccess: "Известување за успех",
      snackbarError: "Известување за грешка",
      snackbarWarning: "Известување за предупредување",
      snackbarInfo: "Информативно известување",
      fullPageSpinner: "Полностраничен спинер",
      comingSoon: "Наскоро",
      skeletons: {
        tableRows: "Редови на табела",
        cardAndTable: "Карта + редови на табела",
        patientHeader: "Заглавие на пациент + резултати",
        serviceCards: "Карти на услуги",
      },
    },

    // Info tooltips
    usedIn: {
      server: "Се користи во: Табела со сите посети, Дијалог за резултати, Дијалог за флагови",
      network: "Се користи во: Табела со сите посети, Дијалог за резултати, Дијалог за флагови",
      timeout: "Се користи во: Табела со сите посети, Дијалог за резултати, Дијалог за флагови",
      unknown: "Се користи во: Табела со сите посети, Дијалог за резултати, Дијалог за флагови",
      empty: "Се користи во: Табела со сите посети (нула резултати)",
      filteredEmpty: "Се користи во: Табела со сите посети (применети филтри, нема совпаѓање)",
      paymentRequired: "Се користи во: OTP Резултати (просрочено плаќање)",
      noResults: "Се користи во: OTP/Корпоративни резултати — DepartmentResultsSection #no-data",
      noSamples: "Се користи во: OTP/Корпоративни резултати — SamplesSection #no-data",
      noSales: "Се користи во: OTP Баланс — оддел продажби (нема продажби)",
      noProducts: "Се користи во: OTP Баланс — ProductsTable #no-data (продажбата нема производи)",
      noPayments: "Се користи во: OTP Баланс — PaymentsTable #no-data (продажбата нема плаќања)",
      noVisits: "Се користи во: Досие на пациент — PatientVisitsTable #no-data",
      noTests: "Се користи во: Досие на пациент — PatientTestsTable #no-data",
      noFlaggedResults: "Се користи во: Дијалог за ознаки — визитата нема означени испитувања",
      dialogHistoryEmpty:
        "Се користи во: Дијалог за историја — нема претходни резултати за овој тест",
      dialogResultsEmpty:
        "Се користи во: Дијалог за резултати од визита — нема резултати за прикажување",
      snackbarSuccess: "Се користи во: Чистење на кеш, потврди за PDF",
      snackbarError: "Се користи во: Сите грешки при мутации преку useErrorBoundary",
      snackbarWarning: "Се користи во: Грешки при освежување во позадина",
      snackbarInfo: "Се користи во: Известувања за неимплементирани функции",
      fullPageSpinner:
        "Се користи во: OTP влезна страница (проверка на автентикација), страница за најава",
      comingSoon: "Се користи во: Пребарување, Нови резултати, Означени страници",
      tableRows: "Се користи во: Страница со сите посети",
      cardAndTable: "Се користи во: OTP Баланс",
      patientHeader: "Се користи во: OTP Резултати",
      serviceCards: "Се користи во: Страница За нас (раздел Услуги)",
    },

    // Fixture text
    fixture: {
      serverTitle: "Нешто тргна наопаку",
      serverSubtitle:
        "Настана серверска грешка при вчитување на податоците. Обидете се повторно или контактирајте ја поддршката.",
      networkTitle: "Изгубена конекција",
      networkSubtitle:
        "Нема врска со серверот. Проверете ја интернет конекцијата и обидете се повторно.",
      timeoutTitle: "Истечено време за чекање",
      timeoutSubtitle:
        "Барањето не беше обработено навреме. Веројатно е привремен проблем — обидете се повторно по малку.",
      unknownTitle: "Неочекувана грешка",
      unknownSubtitle: "Настана неочекувана грешка. Обидете се повторно подоцна.",
      emptyTitle: "Нема пронајдени визити",
      emptySubtitle: "Во системот сè уште нема регистрирани визити.",
      filteredEmptyTitle: "Нема соодветни визити",
      filteredEmptySubtitle: "Нема визити кои одговараат на тековните филтери.",
      paymentTitle: "Чека уплата",
      paymentSubtitle:
        "Вашите лабораториски резултати се готови, но пристапот до нив бара плаќање на должниот износ. Ве молиме обратете се на рецепција или касата на лабораторијата.",
      noResultsTitle: "Нема достапни резултати",
      noResultsSubtitle: "Нема регистрирано резултати од испитувања за оваа посета.",
      noSamplesTitle: "Нема евидентирани примероци",
      noSamplesSubtitle: "Нема регистрирано земање зема примероци за оваа посета.",
      noSalesTitle: "Нема регистрирани продажби",
      noSalesSubtitle: "За оваа посета не се регистрирани продажби.",
      noProductsTitle: "Нема евидентирани производи",
      noProductsSubtitle: "Нема регистрирано производи за оваа продажба.",
      noPaymentsTitle: "Нема извршени уплати",
      noPaymentsSubtitle: "За оваа продажба нема регистрирано ниту едно плаќање.",
      noVisitsTitle: "Нема пронајдени визити за овој пациент.",
      noVisitsSubtitle: "Нема забележани визити за овој пациент.",
      noTestsTitle: "Нема пронајдени испитувања за овој пациент.",
      noTestsSubtitle: "Нема забележани испитувања за овој пациент.",
      noFlaggedResultsTitle: "Нема означени резултати",
      noFlaggedResultsSubtitle: "Нема означени резултати во оваа визита.",
      historyEmptyTitle: "Не се пронајдени историски резултати за овој тест",
      historyEmptySubtitle: "Нема забележани претходни резултати за овој тест.",
      retry: "Повторен обид",
      clearFilters: "Чистење на филтрите",
      editFilters: "Промена на филтрите",
      authTitle: "Сесијата истече",
      authSubtitle: "Вашата сесија истече. Најавете се повторно.",
      validationTitle: "Невалиден внес",
      validationSubtitle: "Коригирајте ги означените полиња и обидете се повторно.",
      comingSoonTitle: "Наскоро",
      comingSoonSubtitle: "Оваа функција е во развој.",
      snackbarSuccessText: "Операцијата заврши успешно",
      snackbarErrorText: "Настана грешка. Обидете се повторно.",
      snackbarWarningText: "Освежувањето на податоците не беше успешно.",
      snackbarInfoText: "Функцијата сè уште не е имплементирана.",
      login: "Повторна најава",
      refresh: "Освежување",
    },
  },
};
